import './assets/css/main.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './pages/App.vue';
import router from './router';

const app = createApp(App);

app.use(createPinia());
app.use(router);

router.isReady().then(() => {
  app.mount('#app');
});
